export default __webpack_public_path__ + "static/Overview-2f526148a373d198c0972fac2d1bd2a1.png";